module.exports = __webpack_public_path__ + "static/media/profile.72deed37.svg";